export default {
  input: {
    doNotShowAgain: 'Do not notify me again'
  }
}
